module.exports = __webpack_public_path__ + "img/bigblue.96a14747.svg";